let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hjmdM")).then(() => parcelRequire('a0Otm'));